<template>
    <div class="empty-content-block flex flex-col items-center text-center">
        <template v-if="!$slots.default">
            <h2
                v-if="!titleBtn"
                :class="{ gray, darkgray }"
                v-html="t(title)"
                :style="{ fontWeight: weight, fontSize: fontSize }"
            ></h2>
            <h2 v-else :class="{ gray }">
                {{ t(title) }}
                <button @click="$emit('add')">+ {{ t("expert.add") }}</button>
            </h2>
        </template>

        <slot></slot>

        <p v-if="descr" v-html="descr"></p>
        <p v-else-if="summary" v-html="t(summary)"></p>

        <img v-if="image" :src="`/build/img/${image}.svg`" alt="" />
        <component v-else :is="iconName" />

        <DefaultButton
            class="mt-20"
            v-if="displayBtn"
            :tag="link ? 'a' : undefined"
            text=""
            size="lg"
            :background="btnBackground"
            :text-color="btnTextColor"
            :attrs="{ href: link ? link : '' }"
            @click="$emit('openModal')"
        >
            <template #icon>
                <PlusIcon :fill="btnTextColor ? btnTextColor : '#fff'" :margin-right="5" />
                <span>{{ t(linkText) }}</span>
            </template>
        </DefaultButton>
    </div>
</template>

<script>
import DefaultButton from "@components/Buttons/DefaultButton"
import MailingEmptyInboxIcon from "@icons/MailingEmptyInboxIcon"
import FiltersEmptyInboxIcon from "@icons/FiltersEmptyInboxIcon"
import MailingListsEmptyInboxIcon from "@icons/MailingListsEmptyInboxIcon"
import CourseProgramEmptyIcon from "@icons/CourseProgramEmptyIcon"
import PlusIcon from "@icons/PlusIcon"

export default {
    name: "EmptyContent",
    props: {
        iconName: {
            type: String,
            default: "CourseProgramEmptyIcon"
        },
        image: {
            type: String,
            default: ""
        },
        title: {
            type: String,
            default: "marketing.is_empty"
        },
        summary: {
            type: String,
            default: ""
        },
        descr: {
            type: String,
            default: ""
        },
        link: {
            type: String,
            default: ""
        },
        gray: {
            type: Boolean,
            default: false
        },
        darkgray: {
            type: Boolean,
            default: false
        },
        linkText: {
            type: String,
            default: "expert.nav.newsletter_1"
        },
        displayBtn: {
            type: Boolean,
            default: false
        },
        titleBtn: {
            type: Boolean,
            default: false
        },
        btnBackground: {
            type: String,
            default: "blue"
        },
        btnTextColor: {
            type: String,
            default: undefined
        },
        weight: {
            types: String,
            default: "500"
        },
        fontSize: {
            type: String,
            default: "26px"
        }
    },
    components: {
        PlusIcon,
        MailingListsEmptyInboxIcon,
        MailingEmptyInboxIcon,
        FiltersEmptyInboxIcon,
        CourseProgramEmptyIcon,
        DefaultButton
    }
}
</script>

<style scoped lang="sass">
.empty-content-block
    padding: 60px 0
    min-height: 50vh
    img
        max-width: 100%
    @media screen and (max-width: 640px)
        padding: 20px 0
    img
        max-width: 100%
    h2
        font-family: Inter, sans-serif
        line-height: 160%
        color: #151515
        margin-bottom: 30px
        button
            font-weight: 500
            color: #396fff
            text-underline-offset: 5px
            &:hover
                text-decoration: underline
        &.darkgray
            color: #323030
            font-size: 18px
            margin-bottom: 20px
        &.gray
            color: #98A2B0
            font-size: 18px
            margin-bottom: 20px
        @media screen and (max-width: 960px)
            font-size: 24px
            line-height: 150%
        @media screen and (max-width: 480px)
            font-size: 16px
    svg
        @media screen and (max-width: 767px)
            width: 80%
            margin: 0 auto
            height: 200px
    p
        margin-top: 0
        margin-bottom: 60px
        font-size: 18px
        line-height: 160%
        max-width: 800px
        font-family: Inter, sans-serif
        color: #52565C
        @media screen and (max-width: 960px)
            font-size: 14px
        @media screen and (max-width: 480px)
            font-size: 11px
            line-height: 13px
            br
                display: none
    .default-button
        width: 100%
        max-width: 246px
        height: 45px
        font-size: 15px
        svg
            width: 24px
            margin: 0
            height: 24px
</style>
